import { memo } from "react";
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";
import Head from "next/head";

const HeadComponent = () => {
    return (
        <Head>
            <link rel="preconnect" href="https://analytics.swiggy.com" crossOrigin="anonymous" />
            <link rel="dns-prefetch" href="https://analytics.swiggy.com" />
            <link rel="preconnect" href="https://dinersone-proxy.swiggy.com" crossOrigin="anonymous" />
            <link rel="dns-prefetch" href="https://dinersone-proxy.swiggy.com" />
            <link rel="preconnect" href={process.env.NEXT_PUBLIC_CDN_URL} crossOrigin="anonymous" />
            <link rel="dns-prefetch" href={process.env.NEXT_PUBLIC_CDN_URL} />
            <link
                rel="preload"
                href={getCloudinaryRawUrl("portal/static-assets/lotties/Seeding_EligibleCase%20(1).json")}
                as="fetch"
                crossOrigin="anonymous"
                type="application/json"
            />
            <link
                rel="preload"
                href={getCloudinaryRawUrl("portal/static-assets/lotties/loyalty/qr/LoggedOutQR.json")}
                as="fetch"
                crossOrigin="anonymous"
                type="application/json"
            />
            <link
                rel="preload"
                href="https://media-assets.swiggy.com/portal/static-assets/images/loyalty/ClochNew1.png"
                as="image"
                type="image/png"
            />
            <link
                rel="preload"
                href="https://media-assets.swiggy.com/portal/static-assets/images/loyalty/qr/With%20Grad%202.png"
                as="image"
                type="image/png"
            />
            <title>DineCash Scan and Earn</title>
            <meta name="description" content="DineCash Scan and Earn" />
            <link rel="icon" href="data:;base64,iVBORw0KGgo=" />
            <meta
                name="viewport"
                content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
            />
        </Head>
    );
};

export default memo(HeadComponent);
